import {
  EvidenceTable,
  EvidenceTableHandle,
  EvidenceTableStateKeys,
  useCaseContext,
} from "@/Features";
import { styled } from "@monolith-forensics/monolith-ui";
import { useLayoutEffect, useRef } from "react";

const StyledPage = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1 1 auto;
`;

export const CaseEvidencePage = () => {
  const caseContext = useCaseContext();
  const tableRef = useRef<EvidenceTableHandle>();

  if (!caseContext) {
    throw new Error("Case context not found");
  }

  const { data: caseData } = caseContext;

  // clear selections when table is unmounted so that selected evidence ids don't persist between cases.
  useLayoutEffect(() => {
    tableRef.current?.clearSelections?.();
  }, []);

  return (
    <StyledPage>
      {!!caseData?.case_id && (
        <EvidenceTable
          tableRef={tableRef}
          query={{ case_id: caseData.case_id }}
          stateStoreKey={EvidenceTableStateKeys.CASE_EVIDENCE_TABLE}
        />
      )}
    </StyledPage>
  );
};
